<template>
  <SchoolSwitchScreen v-if="departingSchool" :schoolName="departingSchool.name" :error="schoolDepartureError"
    @retry="retrySchoolDeparture" @choose="chooseSchoolAfterDeparture" />
  <template v-else>
    <div v-if="isDemo" class="fixed top-5 -left-14 z-[9999] w-48 text-center bg-gradient-to-r from-red-600/90 to-red-500/90 backdrop-blur-md text-white py-1 text-[11px] font-black tracking-[0.3em] transform -rotate-45 shadow-[0_4px_12px_rgba(220,38,38,0.3)] pointer-events-none border-b border-white/20">
      DEMO
    </div>
    <div v-if="debugEnabled" class="fixed bottom-3 right-3 z-[9999] flex items-center gap-1.5 bg-amber-500/90 backdrop-blur-md text-black px-2.5 py-1 rounded-full text-[10px] font-black tracking-[0.2em] shadow-lg pointer-events-none">
      <i class="pi pi-wrench text-[10px]"></i> DEBUG
    </div>
    <router-view />
    <ConfirmDialog />
    <ConfirmDialog group="impact-warning" :style="{ width: '480px', maxWidth: '90vw' }" />
    <GeneralModal />
    <Toast />
  </template>
</template>

<script setup lang="ts">
import SchoolSwitchScreen from '@/components/common/SchoolSwitchScreen.vue';
import { departingSchool, schoolDepartureError, retrySchoolDeparture, chooseSchoolAfterDeparture } from '@/services/schoolSwitch';
import { useCBTSessionStore } from './store/cbtSession';
import { useDebugMode, bindDebugModeHotkey } from '@/composables/useDebugMode';
import { useCrossTabAuthSync } from '@/composables/useCrossTabAuthSync';
import { useScrollbarVisibility } from '@/composables/useScrollbarVisibility';
import { useToast } from 'primevue/usetoast';

const isDemo = computed(() => window.location.hostname.includes('demo.'));

const { enabled: debugEnabled } = useDebugMode();
const toast = useToast();

// Log out every open tab when any one tab logs out.
useCrossTabAuthSync();

// Schools with settings.show_scrollbars get visible scrollbars everywhere.
useScrollbarVisibility();

let unbindDebugHotkey: (() => void) | undefined;

onMounted(() => {
  const sessionStore = useCBTSessionStore();
  sessionStore.loadSession();

  // Ctrl + Shift + Alt + D toggles hidden debug tooling.
  unbindDebugHotkey = bindDebugModeHotkey((active) => {
    toast.add({
      severity: active ? 'warn' : 'info',
      summary: active ? 'Debug mode ON' : 'Debug mode OFF',
      detail: active
        ? 'Experimental admin tools are now visible.'
        : 'Experimental admin tools are hidden again.',
      life: 2500,
    });
  });
});

onBeforeUnmount(() => {
  unbindDebugHotkey?.();
});
</script>
